export const UnitActionStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  ON_COOLDOWN: 'ON_COOLDOWN',
  DISABLED_BY_EFFECT: 'DISABLED_BY_EFFECT',
  INSUFFICIENT_ENERGY: 'INSUFFICIENT_ENERGY',
});

export const PlannedActionStatus = Object.freeze({
  PLANNED: 'planned',
  EXECUTING: 'executing',
  RESOLVED_SUCCESS: 'resolved_success',
  RESOLVED_PARTIAL: 'resolved_partial',
  RESOLVED_FAILED: 'resolved_failed',
  CANCELLED: 'cancelled',
});

export const MessageStatus = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  LOG: 'log',
});

export const UnitStatus = Object.freeze({
  Roster: 'unit_roster',
  Deployed: 'unit_deployed',
  Destroyed: 'unit_destroyed',
});

export const PlayerStatusInGame = Object.freeze({
  Lobbying: 'gameplayer_lobbying',
  Lobbied: 'gameplayer_lobbied',
  Deploying: 'gameplayer_deploying',
  Deployed: 'gameplayer_deployed',
  Planning: 'gameplayer_planning',
  Planned: 'gameplayer_planned',
  Viewed: 'viewed', // ✅ NUEVO
});


export const GameStatus = Object.freeze({
  Lobby: 'game_lobby',
  Deploy: 'game_deploy',
  Plan: 'game_plan',
  Resolving: 'game_resolving', // ✅ NUEVO
  Resolved: 'game_resolved',   // ✅ NUEVO
  Finish: 'game_finish',
  Error: 'game_error',
});

// =============================================================================
// 🎬 CINEMATIC SYSTEM ENUMS (moved from constants.js)
// =============================================================================

/**
 * Speed presets for cinematic playback
 */
export const SPEED_PRESETS = Object.freeze({
  SLOW: 0.5,
  NORMAL: 1,
  FAST: 2,
  VERY_FAST: 4
});

/**
 * Artificial action types for START/END states
 */
export const ARTIFICIAL_ACTIONS = Object.freeze({
  START: 'CINEMATIC_START',
  END: 'CINEMATIC_END'
});

/**
 * Visual effect types that can be triggered
 */
export const EFFECT_TYPES = Object.freeze({
  // Unit effects
  MOVE: 'unit_move',
  DEATH: 'unit_death', 
  DAMAGE: 'unit_damage',
  HEAL: 'unit_heal',
  STATUS_APPLY: 'status_apply',
  STATUS_REMOVE: 'status_remove',
  
  // Combat effects
  ATTACK: 'attack',
  PROJECTILE: 'projectile',
  EXPLOSION: 'explosion',
  SHIELD: 'shield',
  
  // UI effects
  CAMERA_FOCUS: 'camera_focus',
  SCREEN_SHAKE: 'screen_shake',
  FLASH: 'flash'
});

/**
 * Animation states for promise tracking
 */
export const ANIMATION_STATES = Object.freeze({
  PENDING: 'pending',
  RUNNING: 'running',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
});

// =============================================================================
// 🎯 CLICK SYSTEM ENUMS
// =============================================================================

/**
 * Click contexts - define what mode the UI is in
 */
export const ClickContext = Object.freeze({
  SELECT: 'select',
  DEPLOY_UNIT: 'deploy_unit',
  TARGET_ACTION: 'target_action',
  DEBUG_KILL: 'debug_kill',
});

/**
 * Clickable types - what kind of object was clicked
 */
export const ClickableType = Object.freeze({
  UNIT: 'unit',
  DEPLOYABLE: 'deployable',
  ACTION: 'action',
  PLANNED_ACTION: 'planned_action',
  TILE: 'tile',
  TERRAIN: 'terrain',
  STRUCTURE: 'structure',
});

// =============================================================================
// 🎭 EFFECT PHASE ENUMS
// =============================================================================

/**
 * Effect phase triggers and lifecycle events
 * Matches backend App\Enums\EffectPhase
 */
export const EffectPhase = Object.freeze({
  // Trigger phases (from database columns)
  ON_TURN_START: 'on_turn_start',
  ON_ATTACKED_POST: 'on_attacked_post',
  ON_ATTACK: 'on_attack',
  ON_KILL: 'on_kill',

  // Lifecycle phases
  ON_APPLY: 'on_apply',
  EXPIRED: 'expired',
  DISPELLED: 'dispelled',
  UNIT_DEATH: 'unit_death',
});

/**
 * Display name mapping for effect phases
 * Used in EventCard to show readable names in timeline
 */
export const EffectPhaseDisplay = Object.freeze({
  [EffectPhase.ON_TURN_START]: 'Turn Start',
  [EffectPhase.ON_ATTACKED_POST]: 'Counter',
  [EffectPhase.ON_ATTACK]: 'On Attack',
  [EffectPhase.ON_KILL]: 'On Kill',
  [EffectPhase.ON_APPLY]: 'Applied',
  [EffectPhase.EXPIRED]: 'Expired',
  [EffectPhase.DISPELLED]: 'Dispelled',
  [EffectPhase.UNIT_DEATH]: 'Removed on Death',
});
